import { ISolicitudDocumentoModel } from "src/app/models/interfaces/solicitud/documento/ISolicitudDocumentModel";
import { SolicitudDocumentoModel } from "src/app/models/solicitud/documento/SolicitudDocumentoModel";
import { ISolicitudPersonaDocumentoValidarModel } from "./interfaces/ISolicitudPersonaDocumentoValidarModel";

export class SolicitudPersonaDocumentoValidarModel implements ISolicitudPersonaDocumentoValidarModel {
    documentos: ISolicitudDocumentoModel[];
    constructor(){
        this.documentos = new Array<SolicitudDocumentoModel>();
    }
}